import { toBigNumber } from '~/utils/numbers'
import styled from 'styled-components'

interface SpreadLabelLiteProps {
  latestBasePrice: number
  latestPrice: number
}

export const usePriceSpread = (
  latestBasePrice: number,
  latestPrice: number,
): string => {
  if (!latestBasePrice || !latestPrice) return '0'
  return toBigNumber(latestPrice)
    .div(toBigNumber(latestBasePrice))
    .minus(1)
    .times(100)
    .toFixed(2)
}

const getSpreadText = (value: string): string => {
  if (!value || isNaN(Number(value))) return ''
  const label = Number(value) <= 0 ? '' : '+'
  return `${label}${value}%`
}

export const SpreadLabelLite: React.FC<SpreadLabelLiteProps> = ({
  latestBasePrice,
  latestPrice,
}) => {
  const priceSpread = usePriceSpread(latestBasePrice, latestPrice)
  // for 0.00xxx case
  if (Number(priceSpread) === 0) return null

  return (
    <Spread below={Number(priceSpread) < 0}>
      {getSpreadText(priceSpread)}
    </Spread>
  )
}

const Spread = styled.span<{
  below: boolean
}>`
  font-weight: 400;
  font-size: 13px;
  line-height: 140%;
  color: ${({ below }) => (below ? ' #E96140' : '#4DBC9B')};

  ${({ theme }) => theme.media.sm`
    font-size: 12px;
  `}
`
